function FileUpload() {
  const self = this;

  self.init = function init(element) {
    const $wrap = $(element);

    if ($wrap.data('app-module-initialized')) return; // Prevent double init

    const $input = $wrap.find('.js-file-upload__input');
    const $file = $wrap.find('.js-file-upload__file');
    const $remove = $wrap.find('.js-file-upload__remove');

    $input.on('change', function onChange() {
      const file = this.files && this.files[0];

      $wrap.toggleClass('is-attached', !!file);

      if (file) {
        $file.text(this.files[0].name);
      }
    });

    $remove.on('click', () => {
      $input.wrap('<form>').closest('form').get(0).reset();
      $input.unwrap().change();
    });

    $wrap.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-file-upload').each(function init() {
      self.init(this);
    });
  };
}

export default new FileUpload();
